import React from "react";
import DotedPart from "../common/DotedPart";
import AboutHeroSection from "./AboutHeroSection";
import AboutOffer from "./AboutOffer";
import AboutOurCore from "./AboutOurCore";
import AboutServices from "./AboutServices";
import Marque from "../common/Marque";
import TeamSection from "./TeamSection";

const IndexAboutUs = () => {
  return (
    <div>
      <AboutHeroSection />
      <DotedPart className="my-[10px] md:my-[40px] mb-[50px] md:mb-[89px]" />
      <TeamSection />
      <Marque
        className="mb-[0px] mt-[50px] 2xl:mb-24 2xl:mt-24 "
        iconList={undefined}
        title={undefined}
      />
      <DotedPart className="my-[50px] md:my-[89px]" />
      <AboutServices />
      <DotedPart className="mt-[70px] md:mt-[0px] mb-[50px] md:mb-[89px]" />
      <AboutOurCore />
      <DotedPart className="my-[50px] md:my-[89px]" />
      <AboutOffer />
      <DotedPart className="mt-[70px] md:mt-[130px] mb-[50px] md:mb-[89px]" />
    </div>
  );
};

export default IndexAboutUs;
